import {createAction} from "redux-act";
import {IBracketRound} from "modules/types";

export const updateBracketConfig = createAction<IBracketRound[]>();
export const updateBracketsSavedStateAction = createAction<boolean>();
export const updateBracketsSavedAtLeastOnceAction = createAction<boolean>();

export const setSelectedBracketIDAction = createAction<number>();
